import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;
const API_URL_OSINT = process.env.VUE_APP_BASE_API_URL_OSINT;

class TargetService {
    getAllTarget() {
        return axios.get(API_URL + 'target', { headers: authHeader() });
    }
    getTargetBy() {
        return axios.get(API_URL + 'target/listBy', { headers: authHeader() });
    }
    getfilterBy(type, key) {
        return axios.get(API_URL + 'target/filterBy?type=' + type + '&key=' + key, { headers: authHeader() });
    }
    getTargetByNews() {
        return axios.get(API_URL + 'target/listByNews', { headers: authHeader() });
    }
    getTargetByBreach() {
        return axios.get(API_URL + 'target/listByNews', { headers: authHeader() });
    }
    getRelatedImage(id) {
        return axios.get(API_URL + 'target/related-image/' + id, { headers: authHeader() });
    }
    createRelatedImage(data) {
        return axios.post(API_URL + 'target/related-image', data, { headers: authHeader() });
    }
    updateRelatedImage(id, data) {
        return axios.patch(API_URL + 'target/related-image/' + id, data, { headers: authHeader() });
    }
    deleteRelatedImage(id) {
        return axios.delete(API_URL + 'target/related-image/' + id, { headers: authHeader() });
    }
    resetRelatedImage(data) {
        return axios.post(API_URL + 'target/reset-related', data, { headers: authHeader() });
    }
    analyticRelatedImage(data) {
        return axios.post(API_URL_OSINT + 'image-analysis/', data, { headers: authHeader() });
    }
    create(data) {
        return axios.post(API_URL + 'target', data, { headers: authHeader(true) });
    }
    edit(id) {
        return axios.put(API_URL + 'target/' + id, "", { headers: authHeader() });
    }
    update(id, data) {
        return axios.post(API_URL + 'target/' + id, data, { headers: authHeader(true) });
    }
    checkSimilar(data) {
        return axios.post(API_URL + 'target/check/similar', data, { headers: authHeader() });
    }
    delete(id) {
        return axios.delete(API_URL + 'target/' + id, { headers: authHeader() });
    }
    getDetailTarget(id) {
        return axios.get(API_URL + 'target/' + id, { headers: authHeader() });
    }
    updateTargetProfile(id, data) {
        return axios.post(API_URL + 'target/' + id, data, { headers: authHeader() });
    }
    updateTargetImages(id, data) {
        return axios.post(API_URL + 'target/change-image/' + id, data, { headers: authHeader() });
    }
    getRelatedTarget(data) {
        return axios.post(API_URL_OSINT + 'sna/relation/', data);
    }
    getTargetProgress(id) {
        return axios.get(API_URL + 'target/progress/'+id, {headers: authHeader() });
    }
}

export default new TargetService();
